// 🔹 Random border color for outputs
function getRandomColor() {
  const colors = [
    "#2563eb",
    "#16a34a",
    "#dc2626",
    "#d97706",
    "#9333ea",
    "#0891b2",
    "#f59e0b",
    "#e11d48",
    "#0ea5e9",
    "#84cc16",
  ];
  return colors[Math.floor(Math.random() * colors.length)];
}

// 🔹 Output Box
export default function OutputBox({ children, type }) {
  const borderColor = type === "error" ? "#dc2626" : getRandomColor();
  const background = type === "error" ? "rgba(220, 38, 38, 0.1)" : "#f9fafb";

  return (
    <div
      className="output-box"
      style={{
        border: `2px dashed ${borderColor}`,
        padding: "0.5rem 1rem",
        borderRadius: "10px",
        background,
        color: "#000",
        marginTop: "0.5rem",
      }}
    >
      {children}
    </div>
  );
}
